import React from 'react';
import {
  IconButton,
  Tooltip,
  Typography,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {useTranslation} from 'react-i18next';

interface RemoveFilterButtonProps {
  label: string;
  onClick: () => void;
}

const RemoveFilterButton: React.FC<RemoveFilterButtonProps> = ({
  label,
  onClick
}) => {
  const {t} = useTranslation();

  const theme = useTheme();
  const biggerScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Tooltip title={t(label)}>
      <Box
        display="flex"
        alignItems="center"
        onClick={onClick}
        sx={{cursor: 'pointer'}}
      >
        <IconButton>
          <DeleteIcon />
        </IconButton>
        <Typography variant={biggerScreen ? 'subtitle1' : 'subtitle2'}>
          {t(label)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default RemoveFilterButton;
